import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ChartsStoreService } from '@app/core/features/charts-store/charts-store.service';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { BaseComponent } from '@app/shared/components/base/base/base.component';
import { CONFIG_NOTFOUND } from '@app/constants/config-common';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent extends BaseComponent implements OnInit {

  public brokenLink = '';
  private contactus = CONFIG_NOTFOUND;

  constructor(
    private translateService: TranslateService,
    private chartStoreService: ChartsStoreService,
  ) {
    super();
  }

  ngOnInit() {
    this.getTranslateContent();
    this.chartStoreService.checkChangeLanguage
      .pipe(distinctUntilChanged())
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => this.getTranslateContent());
  }

  private getTranslateContent() {
    this.translateService.get('PAGE_NOT_FOUND.BROKEN_LINK').subscribe(res =>
      this.brokenLink =
        `<a href='${this.contactus.supportUrl}' style='${this.contactus.cssLink}'>${res}</a>`
    );
  }
}
